import React, { FC, useMemo } from 'react';
import {Flex, Text} from "@keyslabor/shared/ui";
import {DollarIcon} from "@/assets";
import {CalendarIcon, KeyIcon, LocationIcon} from "@/assets/offer";
import {useTranslation} from "react-i18next";
import { Offer} from "@/api/types.ts";

const OfferDetails: FC<{data: Offer}> = ({data}) => {
    const {t} = useTranslation('confirmation')

    const [date, time] = useMemo(() => {
        if (!data?.first_working_day) return ['N/A', ''];
        const dateObj = new Date(data.first_working_day);
        const date = dateObj.toLocaleDateString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric'
        });
        const time = dateObj.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
        return [date, time] as const;
    }, [data?.first_working_day]);

    return (
        <>
            <div className="flex flex-col mt-[70px] justify-self-start px-5 space-y-5">
                {Number(data?.pay_rate) ? (
                  <Flex alignItems="center">
                      <DollarIcon css={`width: 18px;
                          height: 18px;`} />
                      <Text ml="12px" fontWeight="700" fontSize="16px" color="black" mr="4px">
                          {t('pay_rate')}
                      </Text>
                      <Text>${data?.pay_rate}</Text>
                  </Flex>
                ) : null}
                <Flex alignItems="start">
                    <CalendarIcon />
                    <Text ml="12px" fontWeight="700" fontSize="16px" color="black" mr="4px">
                        {t('firstWorkDay')}
                    </Text>
                    <Text>
                        {date}<br/>{time}
                    </Text>
                </Flex>
                <Flex alignItems="center">
                    <KeyIcon />
                    <Text ml="12px" fontWeight="700" fontSize="16px" color="black" mr="4px">
                        {t('position')}
                    </Text>
                    <Text>{data?.position}</Text>
                </Flex>
                <Flex alignItems="center">
                    <LocationIcon />
                    <Text ml="12px" fontWeight="700" fontSize="16px" color="black" mr="4px">
                        {t('location')}
                    </Text>
                    <Text>{data?.property_address}</Text>
                </Flex>
            </div>
            <div className="px-5 mt-10">
                <Text fontWeight="500" fontSize="14px" color="black">
                    {t('notification')}
                </Text>
            </div>
        </>
    );
};

export default OfferDetails;